import { AppConfig } from './app-config.token';
import { resolveApiBaseUrlFromEnv } from './resolve-api-base-url';
import { resolveAuthConfig } from './resolve-auth-config';

const environment = (import.meta.env['VITE_ENV'] ?? 'prod') as AppConfig['environment'];

// FE-85/FE-86: VITE_AUTH_MODE por defecto 'simulada' (deja el comportamiento previo intacto).
// En entra, el backend es el cliente de Entra ID (enmienda E-7): no exige variables adicionales.
const authResuelto = resolveAuthConfig({
  modo: import.meta.env['VITE_AUTH_MODE'],
  environment,
});

export const runtimeConfig: AppConfig = {
  appName: 'consola-ventas',
  // Desarrollo local usa proxy Vite sobre /api. La consola sintetiza identidad con
  // los headers x-corporate-identity-id y x-mfa-verified solo dentro del navegador.
  // Fuera de dev, VITE_API_BASE_URL trae la URL de API Manager (.env.<ambiente>).
  apiBaseUrl: resolveApiBaseUrlFromEnv(import.meta.env['VITE_API_BASE_URL']),
  environment,
  enableI18n: false,
  announcementBanner: '',
  // Fuente compilada para local; providers.ts la vuelve bloqueante fuera de dev.
  panelDesarrolloLocalVisible: true,
  auth: {
    // Replaced by scaffolder with project slug — acts as a namespaced sessionStorage key
    tokenStorageKey: 'consola-ventas',
    authHeader: 'Authorization',
    gatewayLoginUrl: '',
    tokenExchangeUrl: '',
    ...authResuelto,
  },
};
